import { clientWithApiClient } from "../../../client";
import type { ApiClient } from "../../../types";

import type { ListResponse, Response } from "../../../types";
import type {
  VehicleVideo,
  ReorderVehicleVideosRequest,
  CreateYoutubeVideoRequest,
} from "./types";

const list = (apiClient: ApiClient, vehicleId: string) =>
  clientWithApiClient<ListResponse<VehicleVideo>>(
    apiClient,
    `/vehicles/${vehicleId}/videos`,
  );

const get = (apiClient: ApiClient, vehicleId: string, id: string) =>
  clientWithApiClient<Response<VehicleVideo>>(
    apiClient,
    `/vehicles/${vehicleId}/videos/${id}`,
  );

const create = (
  apiClient: ApiClient,
  vehicleId: string,
  formData: FormData,
) => {
  return clientWithApiClient<Response<VehicleVideo>>(
    apiClient,
    `/vehicles/${vehicleId}/videos`,
    {
      method: "POST",
      body: formData,
    },
  );
};

// A YouTube-link video has no file to upload, so it is created with a JSON
// body instead of the multipart `FormData` the file-upload path sends.
const createYoutubeLink = (
  apiClient: ApiClient,
  vehicleId: string,
  request: CreateYoutubeVideoRequest,
) => {
  return clientWithApiClient<Response<VehicleVideo>>(
    apiClient,
    `/vehicles/${vehicleId}/videos`,
    {
      method: "POST",
      body: JSON.stringify({
        video: {
          source: "youtube",
          external_url: request.external_url,
          name: request.name,
        },
      }),
    },
  );
};

const update = (
  apiClient: ApiClient,
  vehicleId: string,
  id: string,
  formData: FormData,
) => {
  return clientWithApiClient<Response<VehicleVideo>>(
    apiClient,
    `/vehicles/${vehicleId}/videos/${id}`,
    {
      method: "PUT",
      body: formData,
    },
  );
};

const remove = (apiClient: ApiClient, vehicleId: string, id: string) =>
  clientWithApiClient(
    apiClient,
    `/vehicles/${vehicleId}/videos/${id}?delete_resource=true&delete_type=hard`,
    {
      method: "DELETE",
    },
  );

const reorder = (
  apiClient: ApiClient,
  vehicleId: string,
  request: ReorderVehicleVideosRequest,
) =>
  clientWithApiClient(apiClient, `/vehicles/${vehicleId}/videos/reorder`, {
    method: "PUT",
    body: JSON.stringify(request),
  });

export const videos = {
  list,
  get,
  create,
  createYoutubeLink,
  update,
  delete: remove,
  reorder,
};
